import {API} from "./Api";
import {Setup} from "./Setup";
import {AxiosCache} from "./AxiosCache/AxiosCache";
import * as Json from "react-qr-scanner/docs/vendors~main.788812bef53b46c949df.bundle";

export async function getPollWithUid_api(id) {
    const token = localStorage.getItem('token')
    return API.get(`/polls/${id}`, {
        headers: {'Authorization': `Bearer ${token}`}
    });
}

export async function pollAnswer_api(id, obj) {
    const token = localStorage.getItem('token')
    return API.post(`/polls/${id}/answer`, obj, {
        headers: {'Authorization': `Bearer ${token}`}
    });
}

export async function getProductsMall_api(mallId) {
    // const mallId = localStorage.getItem('mallId')
    const token = localStorage.getItem('token')
    return API.get(`/shop/${mallId}/mall_products/`, {
        headers: {'Authorization': `Bearer ${token}`}
    });
}

export async function getProductsByTags_api(merchantId, tagUid) {
    let url =`/shop/${merchantId}/product-public/?ordering=regal_index&product_tag__uid=${tagUid}&stock__gt=0`
    let config = {}
    return await AxiosCache({url,config,time: 1})

}

export async function getProductsCategory_api(merchantId, catId, ordering="regal_index" ) {
    // const mallId = localStorage.getItem('mallId')
    // const token = localStorage.getItem('token')


    let url =`/shop/${merchantId}/product-public/?category__uid=${catId}&ordering=${ordering}&stock__gt=0`
    // let url =`/shop/${merchantId}/product-public/?category__uid=${catId}`
    let config = {
        // headers: {'Authorization': `Bearer ${token}`},
        // params: {
        //     category__uid: catId
        // }
    }

    return await AxiosCache({url,config,time: 1})

    // return API.get(`/shop/${merchantId}/product-public/`, {
    //     // headers: {'Authorization': `Bearer ${token}`},
    //     params: {
    //         category__uid: catId
    //     }
    // });
}


export async function getProductsWithBrand_api(merchantId,brandId) {
    let url =`/shop/${merchantId}/product-public/?ordering=regal_index&brand__uid=${brandId}`
    let config = {}

    return await AxiosCache({url,config,time: 1})
}


export async function getProductsCategoryWithTag_api(merchantId, tagId) {
    let url =`/shop/${merchantId}/product-public/?product_tag__uid=${tagId}`
    let config = {}

    return await AxiosCache({url,config,time: 1})
}

export async function getOffProducts_api(mallId) {
    let url =`/shop/${mallId}/mall_products/?sort=-discounts`
    let config = {}
    return await AxiosCache({url,config,time: 1})
}



export async function getAccessToken_api(obj) {
    return API.post(`users/auth/temp_tokens`, obj);
}


export async function CheckinMallAuth(mallId) {
    let token = localStorage.getItem('token');
    return API.post(`/users/check-ins`, {uid: mallId}, {headers: {'Authorization': `Bearer ${token}`}});
}


export async function getMallCats_api() {
    let token = localStorage.getItem('token');
    let mallId = localStorage.getItem('mallId');
    return API.get(`/malls/${mallId}/categories`, {headers: {'Authorization': `Bearer ${token}`}});
}

export async function getFestivalsStatus_api() {
    let token = localStorage.getItem('token');
    let mallId = localStorage.getItem('mallId');
    return API.get(`/malls/${mallId}/campaigns`, {headers: {'Authorization': `Bearer ${token}`}});
}

export async function getMallMerchant_api() {
    let token = localStorage.getItem('token');
    let mallId = localStorage.getItem('mallId');
    return API.get(`/malls/${mallId}/mall-account-merchant-public`);
}

export async function getMallMerchant_v2_api() {
    let token = localStorage.getItem('token');
    let mallId = localStorage.getItem('mallId');
    let resp = await API.get(`/malls/${mallId}/mall-account-merchant-public?v2=true`);
    return resp.data
}

export async function getMallLicense_api() {
    let token = localStorage.getItem('token');
    let mallId = localStorage.getItem('mallId');
    return API.get(`/malls/${mallId}/licenses`);
}


export async function searchOsmAddress_api(term,neshanToken) {
    return API.get(`https://api.neshan.org/v1/search?term=${term}&lat=35.7219&lng=51.3347`,{
        headers:{
            "Api-Key":neshanToken
        }
    });
}

export async function emptyBasket_api(mId) {
    let token = localStorage.getItem('token');
    return API.post(`/shop/cart/empty/`,{},{
        params:{
            merchant:mId
        },
        headers:{
            'Authorization': `Bearer ${token}`
        }
    });
}




export async function getMeds_api(page,mId) {
    let token = localStorage.getItem('token');
    return API.get(`/shop/${mId}/med-order/list`,{
        params:{
            page:page
        },
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
}


export async function sendPresRequest_api(obj, merchantUid = "DY86rrgWwc") {
    let token = localStorage.getItem('token');
    return API.post(`orders/prescriptions/create_prescription/${merchantUid}/`, obj, {headers: {'Authorization': `Bearer ${token}`}});
}


export async function sendPresRequestFile_api(form_data,merchantUid) {
    let token = localStorage.getItem('token');
    return API.post(`orders/prescriptions/create_prescription/${merchantUid}/`, form_data,
        {
            headers: {
                'Authorization': `Bearer ${token}`,
                'content-type': 'multipart/form-data'
            }
        }
    );
}

export async function getRequests_api() {
    let token = localStorage.getItem('token');
    return API.get(`orders/prescriptions/`, {headers: {'Authorization': `Bearer ${token}`}});
}

export async function getRequestDetail_api(id) {
    let token = localStorage.getItem('token');
    return API.get(`orders/prescriptions/${id}/`, {headers: {'Authorization': `Bearer ${token}`}});
}

export async function addPrescriptionsComments_api(id, obj) {
    let token = localStorage.getItem('token');
    return API.post(`orders/prescriptions/${id}/comments`, obj, {headers: {'Authorization': `Bearer ${token}`}});
}

export async function prescriptionsCommentsList_api(id, page = 1) {
    let token = localStorage.getItem('token');
    return API.get(`orders/prescriptions/${id}/comments`,
        {
            headers: {'Authorization': `Bearer ${token}`},
            params: {page: page}
        }
    );
}

export async function getOrderDetail_api(id) {
    let token = localStorage.getItem('token');
    return API.get(`orders/${id}/`,
        {
            headers: {'Authorization': `Bearer ${token}`}
        }
    );
}


export async function SendPresFile(form_data) {
    let token = localStorage.getItem('token');
    return API.post(`/malls/`, form_data,
        {
            headers: {
                'Authorization': `Bearer ${token}`,
                'content-type': 'multipart/form-data'
            }
        }
    );
}

export async function updateOrderAddressTime(orderId,data) {
    let token = localStorage.getItem('token');
    return API.put(`/shop/cart/${orderId}/set_delivery_info/`, data,
        {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
}

export async function createInvoiceFromOrder(orderId) {
    let token = localStorage.getItem('token');
    return API.post(`/shop/cart/${orderId}/create_invoice/`,{},
        {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
}


export async function getRecommendProduct_api(merchantId, catId) {
    let token = localStorage.getItem('token');
    return API.get(`shop/${merchantId}/product/`,
        {
            headers: {'Authorization': `Bearer ${token}`},
            params:{
                category__uid:catId,
                page:1,
                ordering:"created",
                is_available:false
            }
        }
    );
}


export async function getCats_api(mid,pid) {
    // let token = localStorage.getItem('token');

    let url =`/shop/${mid}/product_category_public/?parent__uid=${pid}`
    let config = {}

    return await AxiosCache({url,config,time: 1})

    //return API.get(`/shop/${mid}/product_category_public/?parent__uid=${pid}`);
}

export async function getBreadCrumbs_api(mid,pid) {
    return API.get(`/shop/${mid}/category-parents/?uid=${pid}`);
}




export async function getShopBrands_api(mid,cid,brands) {


    return API.get(`/shop/${mid}/category-brands/${cid}/`);
}


export async function getShopProducts_api(mid,cid,page=1,min=null,max=null,ordering=null,search=null,brands=[],availableF,discountF) {
    let token = localStorage.getItem('token');
    console.log("braaaa : ",brands);

    let par = {
        category__uid:cid==="---"?null:cid,
        page:page,
        ordering:ordering,
        page_size:15,
        search:search,
        is_available:availableF?availableF:null,
        is_discounted:discountF?discountF:null,
        price__gt:min,
        price__lt:max,
        // brand:brands?.map(b=>b.uid)
    }


    let brand_string ="";

    brands.forEach(b=>{
        brand_string += `brand__uid=${b.uid}&`
    })

    brand_string = brand_string.slice(0, -1);

    return API.get(`/shop/${mid}/product-public/?${brand_string}`,
        {
            params:par,
            // headers: {'Authorization': `Bearer ${token}`}
        }
    );
}

export async function getShopCategories_api(mid,cid) {
    let token = localStorage.getItem('token');
    return API.get(`/shop/${mid}/product_category_public/?parent__uid=${cid}`);
}


export async function getBlogsRegal_api() {
    let token = localStorage.getItem('token');
    let mallId = localStorage.getItem('mallId');
    return API.get(`/malls/${mallId}/blog_posts?post_type=blog_post`);
}


export async function getAddressList_api() {
    let token = localStorage.getItem('token');
    return API.get(`/users/address/`,{
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
}



export async function createmedOrder_api(obj) {
    let token = localStorage.getItem('token');
    //
    // var formdata = new FormData();
    // formdata.append("merchant_uid", mId);
    //
    //
    // if(obj.otc_prescription)
    // formdata.append("otc_prescription", Json.stringify(obj.otc_prescription));
    //
    // if(obj.files.length > 0){
    //
    //     obj.files.forEach(f=>{
    //         formdata.append("image_prescription", f, "file");
    //     })
    // }
    //
    //
    // if(obj.e_prescription)
    // formdata.append("e_prescription", Json.parse(obj.e_prescription));


    return API.post(`/shop/med-order/create`,obj,
        {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
}


export async function finialMedOrder_api(mId,non_delivery) {
    let token = localStorage.getItem('token');
    return API.post(`/shop/med-order/${mId}/finalize/`,{non_delivery},
        {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
}



export async function getAddressMedOrder_api(mId,non_delivery) {
    let token = localStorage.getItem('token');
    return API.get(`/users/address/`,
        {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
}




export async function postMessageApi(mId,message) {
    let token = localStorage.getItem('token');
    return API.post(`/shop/med-order/${mId}/finalize/`,message,
        {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
}


export async function getNeshanToken_api(mId) {
    let token = localStorage.getItem('token');
    return API.get(`/users/${mId}/map_key`,
        {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }
    );
}



